import { render } from "./LogoUploadContainer.vue?vue&type=template&id=b3f245b6"
import script from "./LogoUploadContainer.vue?vue&type=script&lang=js"
export * from "./LogoUploadContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__